import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PagerDefault as Pager } from 'rp-react-pagination';
import DataTable from './GridDataTable';
import tableConfig from '../config/previouslySoldLotsTable';
import { updatePagerAndLotsFound,
    updateTableOnPageChange,
    initialTableUpdate
} from '../helpers/dispatchProps';
/**
 * Reducer state key
 * @type {string}
 */
const stateKey = 'previouslySold';

/**
 * @type {number}
 */
const pagerLength = 5;

/**
 * Previously sold lots page
 *
 * @param {{}} props
 * @constructor
 */
const PreviouslySoldLots = props => (
    <div className="table__PreviouslySoldLots">
        <DataTable
            config={tableConfig}
            stateKey={stateKey}
            errorMessage="No previously sold lots in our records for this sale"
            onMount={initialTableUpdate(tableConfig.url)}
            onAfterUpdate={props.onAfterUpdate}
        />
        <Pager
            onPageChange={props.onPageChange}
            stateKey={stateKey}
            pageSize={50}
            pagerLength={pagerLength}
            offsetRange={5}
        />
    </div>
);

PreviouslySoldLots.propTypes = {
    /**
     * DataTable onAfterUpdate event handler
     * Dispatch prop
     */
    onAfterUpdate: PropTypes.func,
    /**
     * Pager onPageChange event handler
     * Dispatch prop
     */
    onPageChange: PropTypes.func,
};

/**
 * Create component properties based on app state
 * No state props for this component
 *
 * @returns {{}} Empty object
 */
function mapStateToProps() {
    return {};
}

/**
 * Create component callable properties
 *
 * @returns {{}} Properties
 */
function mapDispatchToProps(dispatch) {
    const onAfterUpdate = updatePagerAndLotsFound(stateKey, pagerLength);

    return {
        onAfterUpdate,
        onPageChange: updateTableOnPageChange(dispatch, stateKey, tableConfig.url, onAfterUpdate)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PreviouslySoldLots);



// WEBPACK FOOTER //
// ./src/js/containers/PreviouslySoldLots.js